import { fetchApi } from '@/config/axiosSetting';
import {
  GetChassisPlaceQueryParamsType,
  GetChassisPlaceQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getChassisPlace/getChassisPlaceQuery.type';

export const getChassisPlaceFunction = (
  params: GetChassisPlaceQueryParamsType,
): Promise<GetChassisPlaceQueryResponseType> => {
  return fetchApi.get(`defaults/${params.id}/chassis_engraving/`);
};
